// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"160":"7d1720fd","388":"bdfdd374","451":"6fd6a656","665":"47d99636","778":"6d345a89","787":"dd76db5b","882":"b62395d7"}[chunkId] + ".chunk.js";
};